import styled from 'styled-components'
import PanelButton from '@pc/components/Works/Panel/shared/button/PanelButton'

const JobPanelButton = styled(PanelButton)`
  height: 40px;
  min-width: 120px;
`

export default JobPanelButton
